var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadEyeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 97,
    viewBox: "0 0 116 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_954_14806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7445 90.5872C83.8571 90.5872 102.594 71.6273 102.594 48.2391C102.594 24.8509 83.8571 5.89103 60.7445 5.89103C37.6318 5.89103 18.8953 24.8509 18.8953 48.2391C18.8953 71.6273 37.6318 90.5872 60.7445 90.5872Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4346 4.07523L87.6006 0.666854C87.1153 0.383332 86.4948 0.551586 86.2146 1.04266L85.3414 2.57319C85.0612 3.06427 85.2275 3.6922 85.7127 3.97572L91.5467 7.3841C92.032 7.66762 92.6525 7.49937 92.9327 7.0083L93.8059 5.47776C94.0861 4.98669 93.9198 4.35876 93.4346 4.07523Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.881 30.0779L108.781 30.1116C106.735 30.667 104.606 29.674 103.691 27.7383C96.0069 11.3276 79.5068 0 60.3952 0C44.4107 0 30.2558 7.91081 21.5566 20.08C20.3424 21.78 18.0969 22.3859 16.2007 21.5612C10.8116 19.2048 9.0651 13.5999 5.67193 10.7048C4.74047 9.91376 3.39318 10.0652 2.64468 11.0246C2.01262 11.8662 1.24749 12.8761 0.698595 13.583C0.249498 14.189 0 14.9295 0 15.687C0 19.6929 0 32.8214 0 40.4798C0 44.0481 2.11242 47.2629 5.35589 48.6599C6.80298 49.2827 8.3166 49.9054 9.93003 50.5282C11.5434 51.151 12.608 52.5143 12.7909 54.1806C15.5687 78.2834 35.8113 97 60.3786 97C81.8188 97 99.9822 82.7437 106.087 63.0845C106.536 61.637 107.733 60.5598 109.18 60.1895C113.172 59.1628 115.983 55.5272 115.983 51.3529V35.5818C115.983 31.8116 112.457 29.0849 108.864 30.0779H108.881ZM63.9713 83.8882C41.7494 86.11 23.22 67.3597 25.4155 44.8728C27.0456 28.2264 40.3522 14.7612 56.8024 13.1117C79.0244 10.89 97.5538 29.6403 95.3582 52.1272C93.7281 68.7736 80.4216 82.2388 63.9713 83.8882Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6633 70.4904C73.7367 70.4904 85.1454 58.9456 85.1454 44.7045C85.1454 30.4633 73.7367 18.9186 59.6633 18.9186C45.59 18.9186 34.1812 30.4633 34.1812 44.7045C34.1812 58.9456 45.59 70.4904 59.6633 70.4904Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7672 20.6691H61.4597L59.6134 45.0075L57.7672 20.6691Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7672 68.7399H61.4597L59.6134 44.4015L57.7672 68.7399Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4155 43.1392V46.8758L59.3639 45.0075L83.4155 43.1392Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9277 43.1392V46.8758L59.9627 45.0075L35.9277 43.1392Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1488 26.6948L77.7602 29.3373L59.4471 45.2263L75.1488 26.6948Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5664 60.6776L44.1778 63.3201L59.8795 44.7887L41.5664 60.6776Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4732 60.2986L74.8618 62.9411L59.16 44.4096L77.4732 60.2986Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1778 26.6948L41.5664 29.3373L59.8795 45.2263L44.1778 26.6948Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07 23.6483L51.4299 22.0998L59.7465 45.0075L48.07 23.6483Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8136 67.3597L71.1735 65.8112L59.497 44.452L67.8136 67.3597Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6212 33.2927L82.1514 36.6927L59.5136 45.1084L80.6212 33.2927Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4247 53.2717L38.955 56.6717L60.0625 44.856L37.4247 53.2717Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3499 21.8136L69.8096 23.1265L59.68 45.2768L66.3499 21.8136Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7666 66.8548L53.2263 68.1508L59.8962 44.7045L49.7666 66.8548Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6837 51.6222L81.4029 55.1232L59.5136 44.8728L82.6837 51.6222Z",
    fill: "#B5E0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1898 34.8412L36.8925 38.3422L60.0791 45.0916L38.1898 34.8412Z",
    fill: "#B5E0F5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.7319 58.6915C66.3657 58.6915 72.5541 52.4293 72.5541 44.7045C72.5541 36.9797 66.3657 30.7175 58.7319 30.7175C51.0981 30.7175 44.9097 36.9797 44.9097 44.7045C44.9097 52.4293 51.0981 58.6915 58.7319 58.6915Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.64 33.8916C65.2026 33.8916 67.28 31.7986 67.28 29.2169C67.28 26.6351 65.2026 24.5422 62.64 24.5422C60.0774 24.5422 58 26.6351 58 29.2169C58 31.7986 60.0774 33.8916 62.64 33.8916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7 21.0361C67.661 21.0361 68.44 20.2513 68.44 19.2831C68.44 18.315 67.661 17.5301 66.7 17.5301C65.739 17.5301 64.96 18.315 64.96 19.2831C64.96 20.2513 65.739 21.0361 66.7 21.0361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_954_14806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadEyeLogo);
export default __webpack_public_path__ + "static/media/MadEyeLogo.d1c4b43ad56c38cf0b4f1b72a77ea54f.svg";
export { ForwardRef as ReactComponent };